"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useAppAtomStyleFromControlStyle_1 = __importDefault(require("../../../hooks/useAppAtomStyleFromControlStyle"));
const computeImageStyle = (style) => ({
    borderBottomLeftRadius: style.borderBottomLeftRadius,
    borderBottomRightRadius: style.borderBottomRightRadius,
    borderTopLeftRadius: style.borderTopLeftRadius,
    borderTopRightRadius: style.borderTopRightRadius,
    width: '100%',
    height: '100%',
});
const ViewWithImageBackground = ({ containerControlStyle, events, backgroundImage, children, resizeMode, isContainerViewScroll, }) => {
    const { Render, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const source = (0, react_1.useMemo)(() => ({ uri: backgroundImage || undefined }), [backgroundImage]);
    const getAtomStyle = (0, useAppAtomStyleFromControlStyle_1.default)();
    const style = getAtomStyle(containerControlStyle);
    const staticImageBackgroundStyle = (0, react_1.useMemo)(() => {
        const computedStyle = Object.assign(Object.assign({}, style), { width: '100%', height: '100%', position: 'relative', top: 0, left: 0 });
        delete computedStyle.minWidth;
        delete computedStyle.maxWidth;
        delete computedStyle.maxHeight;
        delete computedStyle.minHeight;
        delete computedStyle.borderStyle;
        if (events === null || events === void 0 ? void 0 : events.onPress) {
            delete computedStyle.marginBottom;
            delete computedStyle.marginLeft;
            delete computedStyle.marginRight;
            delete computedStyle.marginTop;
        }
        return computedStyle;
    }, [style, events === null || events === void 0 ? void 0 : events.onPress]);
    const staticTouchableImageBackgroundStyle = (0, react_1.useMemo)(() => {
        const computedStyle = Object.assign({}, style);
        delete computedStyle.paddingBottom;
        delete computedStyle.paddingLeft;
        delete computedStyle.paddingRight;
        delete computedStyle.paddingTop;
        return computedStyle;
    }, [style]);
    const { isScroll, scroll } = isContainerViewScroll || {};
    const handleOnScrollBeginDrag = (0, react_1.useCallback)((e) => {
        if (events === null || events === void 0 ? void 0 : events.onScrollBeginDrag) {
            const { x, y } = e.nativeEvent.contentOffset;
            events.onScrollBeginDrag((scroll === null || scroll === void 0 ? void 0 : scroll.horizontal) ? x : y);
        }
    }, [events, scroll]);
    const handleOnScrollEndDrag = (0, react_1.useCallback)((e) => {
        if (events === null || events === void 0 ? void 0 : events.onScrollEndDrag) {
            const { x, y } = e.nativeEvent.contentOffset;
            events.onScrollEndDrag((scroll === null || scroll === void 0 ? void 0 : scroll.horizontal) ? x : y);
        }
    }, [events, scroll]);
    const container = () => {
        if (backgroundImage) {
            if ((events === null || events === void 0 ? void 0 : events.onPress) || (events === null || events === void 0 ? void 0 : events.onLongPress) || (events === null || events === void 0 ? void 0 : events.onPressOut)) {
                return (react_1.default.createElement(Render.TouchableOpacity, { style: staticTouchableImageBackgroundStyle, onPress: events.onPress, onPressOut: events.onPressOut, onLongPress: events.onLongPress },
                    react_1.default.createElement(Render.ImageBackground, { resizeMode: resizeMode, style: staticImageBackgroundStyle, imageStyle: computeImageStyle(style !== null && style !== void 0 ? style : {}), source: source }, children)));
            }
            return (react_1.default.createElement(Render.ImageBackground, { resizeMode: resizeMode, style: style, imageStyle: computeImageStyle(style !== null && style !== void 0 ? style : {}), source: source }, children));
        }
        if ((events === null || events === void 0 ? void 0 : events.onPress) || (events === null || events === void 0 ? void 0 : events.onLongPress) || (events === null || events === void 0 ? void 0 : events.onPressOut)) {
            return (react_1.default.createElement(Render.TouchableOpacity, { style: style, onPress: events.onPress, onLongPress: events.onLongPress, onPressOut: events.onPressOut }, children));
        }
        return (react_1.default.createElement(Render.View, { style: style }, children));
    };
    return isScroll ? (react_1.default.createElement(Render.ScrollView, { style: {
            width: style === null || style === void 0 ? void 0 : style.width,
            height: style === null || style === void 0 ? void 0 : style.height,
        }, horizontal: scroll === null || scroll === void 0 ? void 0 : scroll.horizontal, onScrollBeginDrag: handleOnScrollBeginDrag, onScrollEndDrag: handleOnScrollEndDrag }, container())) : container();
};
exports.default = ViewWithImageBackground;
